/**
  All of the routes for the Material Dashboard 2 PRO React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Sidenav.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `type` key with the `title` value is used for a title inside the Sidenav.
  3. The `type` key with the `divider` value is used for a divider between Sidenav items.
  4. The `name` key is used for the name of the route on the Sidenav.
  5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The `collapse` key is used for making a collapsible item on the Sidenav that contains other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  8. The `auth` key is used for marking an item on the Sidenav that require authentication to access the link.
  9. The `permissions` key is used for marking an item on the Sidenav that require specified roles to access the link.
  10. The `route` key is used for the "path" parameter of <Route> component.
  11. The `link` key is used for the "to" parameter of <Link> component.
  12. The `href` key is used to store the external links location.
  13. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
  14. The `component` key is used to store the component of its route.
*/

import { Navigate } from "react-router-dom";

import AccountProfile from "pages/account/manage/AccountProfile";
import ShowDashboard from "pages/dashboard/ShowDashboard";
import ShowLiveView from "pages/liveview/ShowLiveView";
import ShowHistory from "pages/history/ShowHistory";

import SetSystemSettings from "pages/system/manage/SetSystemSettings";

//import ManageCompany from "pages/settings/company/manage/ManageCompany";
//import NewUser from "pages/settings/user/new/NewUser";
import Users from "pages/settings/users2/Users";
import AlertRecipients from "pages/settings/alertrecipients/AlertRecipients";
//import ManageUsers from "pages/settings/users/manage/ManageUsers";
import UserStatistics from "pages/settings/userstatistics/manage/UserStatistics";
import ManageRoles from "pages/settings/roles/manage/ManageRoles";

import Landing from "pages/main/landing";

//import QASurveyProxy from "pages/assessments/manage/QASurveyProxy";
//import QAAdvisoryProxy from "pages/assessments/advisory/QAAdvisoryProxy";
//import QAScoreProxy from "pages/assessments/score/QAScoreProxy";

//import Tracking from "pages/tracking/manage/Tracking";
//import TrackingWeekly from "pages/tracking/manageweekly/TrackingWeekly";

import SignIn from "pages/authentication/signin";
import SignUp from "pages/authentication/signup";
import VerifyEmail from "pages/authentication/verifyemail";
import ResetPassword from "pages/authentication/resetpassword";

import MDAvatar from "components/atoms/MDAvatar";

//import QuestionAnswerIcon from "@mui/icons-material/QuestionAnswer";
import SettingsIcon from "@mui/icons-material/Settings";
import CloudSyncIcon from "@mui/icons-material/CloudSync";
import DetailIcon from "@rsuite/icons/Detail";

import { Permission } from "models/abac";

const defaultSignedInPath = "/liveview"; //"/account/profile";

/*const padTo2Digits = (num) => {
  return String(num).padStart(2, "0");
};
const now = new Date();
*/
const navigate = (displayName, displayNameKey) => {
  return [
    {
      name: displayName ?? "Unknown",
      key: displayNameKey ?? "unknown",
      auth: true,
      permissions: Permission.VIEW_MEMBER_DASHBOARD,
      link: `/account/profile`,
      route: `/account/profile`,
      component: <AccountProfile />,
      icon: (
        <MDAvatar bgColor="info" size="sm">
          {displayName?.charAt(0).toUpperCase()}
        </MDAvatar>
      ),
    },
    {
      type: "divider",
      key: "divider-action",
    },
    {
      type: "title",
      title: "Action",
      key: "title-action",
    },
    {
      name: "Dashboard",
      key: "dashboard",
      auth: true,
      permissions: [Permission.VIEW_MEMBER_DASHBOARD],
      icon: <DetailIcon />,
      route: "/dashboard",
      link: "/dashboard",
      component: <ShowDashboard />,
    },
    {
      name: "Live View",
      key: "liveview",
      auth: true,
      permissions: [Permission.VIEW_MEMBER_DASHBOARD],
      icon: <CloudSyncIcon />,
      route: "/liveview",
      link: "/liveview",
      component: <ShowLiveView />,
    },
    {
      name: "History",
      key: "history",
      auth: true,
      permissions: [Permission.VIEW_MEMBER_DASHBOARD],
      icon: <CloudSyncIcon />,
      route: "/history",
      link: "/history",
      component: <ShowHistory />,
    },
    {
      type: "divider",
      key: "divider-manage",
      auth: true,
      permissions: [Permission.VIEW_ADMIN_DASHBOARD],
    },
    {
      type: "title",
      title: "System",
      key: "title-system",
      auth: true,
      permissions: [Permission.VIEW_ADMIN_DASHBOARD],
    },
    {
      name: "System Settings",
      key: "set-system-settings",
      auth: true,
      permissions: [Permission.VIEW_ADMIN_DASHBOARD],
      icon: <SettingsIcon />,
      route: "/system/settings",
      link: "/system/settings",
      component: <SetSystemSettings />,
    },

    /*{
      type: "divider",
      key: "divider-manage",
      auth: true,
      permissions: [
        Permission.VIEW_ADMIN_DASHBOARD,
        //Permission.VIEW_SUPERADMIN_DASHBOARD,
      ],
    },
    {
      type: "title",
      title: "Manage",
      key: "title-manage",
      auth: true,
      permissions: [
        Permission.VIEW_ADMIN_DASHBOARD,
        //Permission.VIEW_SUPERADMIN_DASHBOARD,
      ],
    },*/
    /*{
      type: "collapse",
      name: "Assessments",
      key: "assessments",
      auth: true,
      permissions: Permission.VIEW_SETTINGS_ACTION,
      icon: <QuestionAnswerIcon />,
      collapse: [
        {
          name: "Questionnaire",
          key: "que-ans",
          auth: true,
          permissions: [
            Permission.VIEW_ADMIN_DASHBOARD,
            Permission.VIEW_SUPERADMIN_DASHBOARD,
          ],
          route: "/assessments/qasurvey",
          link: "/assessments/qasurvey",
          component: <QASurveyProxy />,
        },
        {
          name: "Advisories",
          key: "advisories",
          auth: true,
          permissions: [
            Permission.VIEW_ADMIN_DASHBOARD,
            Permission.VIEW_SUPERADMIN_DASHBOARD,
          ],
          route: "/assessments/qaadvisory",
          link: "/assessments/qaadvisory",
          component: <QAAdvisoryProxy />,
        },
        {
          name: "Scores",
          key: "scores",
          auth: true,
          permissions: [
            Permission.VIEW_ADMIN_DASHBOARD,
            Permission.VIEW_SUPERADMIN_DASHBOARD,
          ],
          route: "/assessments/qascore",
          link: "/assessments/qascore",
          component: <QAScoreProxy />,
        },
      ],
    },*/
    /*{
      type: "collapse",
      name: "Tracking",
      key: "tracking",
      auth: true,
      permissions: Permission.VIEW_SETTINGS_ACTION,
      icon: <QuestionAnswerIcon />,
      collapse: [
        {
          name: "Daily Log",
          key: "daily-log",
          auth: true,
          permissions: [
            Permission.VIEW_ADMIN_DASHBOARD,
            Permission.VIEW_SUPERADMIN_DASHBOARD,
          ],
          //route: "/tracking/dailylog",
          link:
            "/tracking/dailylog/" +
            padTo2Digits(now.getDate()) +
            padTo2Digits(now.getMonth() + 1) +
            padTo2Digits(now.getFullYear()),
          component: <Tracking />,
        },
        {
          name: "Weekly Log",
          key: "weekly-log",
          auth: true,
          permissions: [
            Permission.VIEW_ADMIN_DASHBOARD,
            Permission.VIEW_SUPERADMIN_DASHBOARD,
          ],
          route: "/tracking/weeklylog",
          link: "/tracking/weeklylog",
          component: <TrackingWeekly />,
        },
      ],
    },*/

    {
      type: "divider",
      key: "divider-settings",
      auth: true,
      permissions: Permission.VIEW_ADMIN_DASHBOARD,
    },
    {
      type: "title",
      title: "Admin",
      key: "title-admin",
      auth: true,
      permissions: Permission.VIEW_ADMIN_DASHBOARD,
    },
    {
      type: "collapse",
      name: "Settings",
      key: "settings",
      auth: true,
      permissions: Permission.VIEW_ADMIN_DASHBOARD,
      icon: <SettingsIcon />,
      collapse: [
        {
          name: "Users",
          key: "users",
          auth: true,
          permissions: [
            Permission.VIEW_ADMIN_DASHBOARD,
            //Permission.VIEW_SUPERADMIN_DASHBOARD,
          ],
          route: "/settings/users",
          link: "/settings/users",
          component: <Users />,
        },
        {
          name: "Alert Recipients",
          key: "alert-recipients",
          auth: true,
          permissions: [
            Permission.VIEW_ADMIN_DASHBOARD,
            //Permission.VIEW_SUPERADMIN_DASHBOARD,
          ],
          route: "/settings/alert-recipients",
          link: "/settings/alert-recipients",
          component: <AlertRecipients />,
        },

        /*{
          name: "New User",
          key: "new-user",
          auth: true,
          permissions: [
            Permission.VIEW_ADMIN_DASHBOARD,
            //Permission.VIEW_SUPERADMIN_DASHBOARD,
          ],
          route: "/settings/user",
          link: "/settings/user",
          component: <NewUser />,
        },*/
        /*{
          name: "Users",
          key: "manage-users",
          auth: true,
          permissions: [
            Permission.VIEW_ADMIN_DASHBOARD,
            //Permission.VIEW_SUPERADMIN_DASHBOARD,
          ],
          route: "/settings/users",
          link: "/settings/users",
          component: <ManageUsers />,
        },*/
        {
          name: "User Statistics",
          key: "manage-user-statistics",
          auth: true,
          permissions: Permission.VIEW_ADMIN_DASHBOARD,
          route: "/settings/userStatistics",
          link: "/settings/userStatistics",
          component: <UserStatistics />,
        },
        {
          name: "Roles",
          key: "manage-roles",
          auth: true,
          permissions: Permission.VIEW_SUPERADMIN_DASHBOARD,
          route: "/settings/roles",
          link: "/settings/roles",
          component: <ManageRoles />,
        },
      ],
    },
    {
      name: "Landing",
      key: "landing",
      route: "/main/landing",
      component: <Landing />,
    },
    {
      name: "Sign In",
      key: "sign-in",
      route: "/authentication/signin",
      component: <SignIn />,
    },
    {
      name: "Sign Up",
      key: "sign-up",
      route: "/authentication/signup",
      component: <SignUp />,
    },
    {
      name: "Reset Password",
      key: "reset-password",
      route: "/authentication/resetpassword",
      component: <ResetPassword />,
    },
    {
      name: "Verify Email",
      key: "verify-email",
      auth: true,
      route: "/authentication/verifyemail",
      component: <VerifyEmail />,
    },
    {
      name: "All",
      key: "all",
      route: "*",
      /*component: <Navigate to={`/main/landing`} />,*/
      component: <Navigate to={`/account/profile`} />,
    },

    /*{
      name: "Manage Daily Log",
      key: "manage-daily-log",
      auth: true,
      route: "/tracking/dailylog/:date",
      component: <Tracking />,
    },*/
    /*{
      name: "Manage QA Survey",
      key: "manage-qa-survey",
      auth: true,
      route: "/assessments/:mode",
      component: <QASurveyProxy />,
    },
    {
      name: "Manage QA Advisory",
      key: "manage-qa-advisory",
      auth: true,
      route: "/assessments/:mode",
      component: <QAAdvisoryProxy />,
    },*/
  ];
};

export { navigate as default, defaultSignedInPath };
